export const SET_AUTH = "SET_AUTH";
export const SET_C_USER = "SET_C_USER";
export const SET_CUSTOMER = "SET_CUSTOMER";
export const SET_SUPPLIERINFO = "SET_SUPPLIERINFO";
export const SET_SUPPLIERPHONE = "SET_SUPPLIERPHONE";
export const SET_AVATAR = "SET_AVATAR";
export const SET_BASKET = "SET_BASKET";
export const DELETE_BASKET = "DELETE_BASKET";
export const CLEAR_BASKET = "CLEAR_BASKET";
export const LOG_OUT = "LOG_OUT";
export const ADMIN_SET_AUTH = "ADMIN_SET_AUTH";
export const ADMIN_LOG_OUT = "ADMIN_LOG_OUT";
export const SET_LANGUAGE = "SET_LANGUAGE";
export default {
  SET_AUTH,
  SET_C_USER,
  SET_CUSTOMER,
  SET_SUPPLIERINFO,
  SET_SUPPLIERPHONE,
  SET_AVATAR,
  SET_BASKET,
  DELETE_BASKET,
  CLEAR_BASKET,
  LOG_OUT,
  ADMIN_SET_AUTH,
  ADMIN_LOG_OUT,
  SET_LANGUAGE
};
